"use strict";

const MuniPipesGeoServerLayer = function () {
  const layerName = "muniPipes";
  const layerKey = "muniPipesLayer";

  var getUnsavedIconMarker = function () {
    return L.divIcon({
      iconSize: [24, 24],
      popupAnchor: [0, 5],
      className: RoutineMaintenanceIcon.getMaintenanceIcon("muni-pipes", null).class,
    });
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const muniPipesGeoServerLayer = new GeoServerMapLayer(layerName, layerKey);
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, muniPipesGeoServerLayer);

    muniPipesGeoServerLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    muniPipesGeoServerLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    MuniPipesPopup.invalidatePopupCache();
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await ApiCalls.getMuniPipes();
    return _organizeLayerData(data);
  };

  var _organizeLayerData = function (layerData) {
    return layerData.map((data) => getOrganizedProperties(data));
  };

  var getOrganizedProperties = function (data) {
    return {
      id: data.id,
      groupId: data.group_id,
      name: data.name,
      type: data.pipe_type,
      cof: data.cof_final_text,
      material: data.material,
      phase: data.phase,
      landOwnership: data.property,
      implementerType: data.implementer_type,
      maintainedBy: data.responsible_party_maintenance,
      installDate: data.install_date,
      flowType: data.flow_direction,
      serviceType: data.line_service_type,
      accessible: data.accessible,
      shape: data.shape,
      lined: data.lined,
      correctiveAction: data.corrective_actions ? JSON.parse(data.corrective_actions) : null,
      enforcementLevel: data.severity ? JSON.parse(data.severity) : null,
      condition: data.condition,
      icon: RoutineMaintenanceIcon.getMaintenanceIcon("muni-pipes", data.condition),
      diameter: data.diameter,
      diameterUnits: data.diameter_units,
      length: data.length,
      lengthUnits: data.length_units,
      width: data.width,
      widthUnits: data.width_units,
      catchment_names: JSON.parse(data.catchment_names),
      drains_to_rws: JSON.parse(data.drains_to_rws),
      drains_to_cs: JSON.parse(data.drains_to_cs),
      zone_names: data.zone_names ? JSON.parse(data.zone_names) : null,
      routine: DateTime.parseJsonIsoDateArray(data.routine_inspection_dates),
      repair: DateTime.parseJsonIsoDateArray(data.repair_dates),
    };
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    getLayerData,
    invalidateLayerData,
    _organizeLayerData,
    getUnsavedIconMarker,
  };
};

module.exports = MuniPipesGeoServerLayer();

const GeoServerLayerFunctions = require("../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../mapFunctions/geoServerMapLayer");
const MuniPipesPopup = require("./muniPipesPopup");
const RoutineMaintenanceIcon = require("../general/routineMaintenanceIcon");
const ApiCalls = require("../apiCalls");
const DateTime = require("../dateTime");
